module.exports = __webpack_public_path__ + "static/img/1-1.cf724e7e.webp";